module.exports = __webpack_public_path__ + "static/Leidy-Arias-962a080133c72ee7654bbaf640a5df19.png";